import Vue from 'vue';
import VueLocalStorage from 'vue-ls';
import store from '../store/index';

Vue.use(VueLocalStorage);
store.state.fill = true;

const appSections = {  
  DASHBOARD:	'DASHBOARD',
  HISTORIC_ALARM: 'HISTORIC_ALARM',
  HISTORIC_REPORT: 'HISTORIC_REPORT',
  PRESION :	'PRESION',  
  BINNACLE : 'BINNACLE',
  CAMP: 'CAMP',
  DIR_GENERAL :	'DIR_GENERAL',
  DIR_TREND : 'DIR_TREND',
  REPORT_POLL :	'REPORT_POLL',
  REPORT_TABLE_POLL : 'REPORT_TABLE_POLL',
  MONITOR : 'MONITOR',
  HELP : 'HELP',
  HEALTH : 'HEALTH',
};

const jwtDecode = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
};

const getRecoveryGuid = () => {
  const recovery = store.state.recovery;
  
  if (!recovery){
    return null;
  }

  return recovery.recoveryGuid;
}

const getUser = () => {
  let user = store.state.user;

  if (!user){
    user = Vue.ls.get('user');
  }
  if(!user) {
    return null;
  }

  try {
    const decodedUser = jwtDecode(user.accessToken);
    decodedUser.permissions = decodedUser.permissions && JSON.parse(decodedUser.permissions);
    return decodedUser;
  } catch (error) {
    return null;
  }
}

const isTokenExpired = (user) => {
  if(!user) {
    return true;
  }

  const currentTime = Date.now() / 1000; // Convert to seconds
  if(user && user.exp > currentTime) {
    return false;
  }

  if(this.$store) {
    this.$store.dispatch('clearUser');
  }
  return true;
};

const userHasAccess = (appSection, user, from) => {
  const permissions = user && user.permissions;  
  var found = permissions && permissions.find(x => x === appSection);
  return found;
};

const Gard = {
  
  dashboardGard(to, from, next) {        
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.DASHBOARD, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  historicAlarmGard(to, from, next) {    
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.HISTORIC_ALARM, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  historicDetailAlarmGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.HISTORIC_ALARM, user, from)) {
      next();
    } else if (userHasAccess(appSections.DASHBOARD, user, from)) {
        next();
    } else {
      next('/unauthorized');  
    }
  },  
  historicReportGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.HISTORIC_REPORT, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  presionGard(to, from, next) {    
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.PRESION, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  binnacleGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.BINNACLE, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  campGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.CAMP, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  dirGeneralGard(to, from, next) {    
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.DIR_GENERAL, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  dirTrendGard(to, from, next) {    
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.DIR_TREND, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  reportPollGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.REPORT_POLL, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  reportTablePollGard(to, from, next) {    
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.REPORT_TABLE_POLL, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  monitorGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.MONITOR, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },
  healthGard(to, from, next) {
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (userHasAccess(appSections.HEALTH, user, from)) {
      next();
    } else {
      next('/unauthorized');  
    }
  },  
  userHasAccess(appSection){
    const user = getUser();
    if (!user || isTokenExpired(user)) {
      return false;
    }
    return userHasAccess(appSection, user, null);
  },
  recoveryGard(to, from, next) {
    const recoveryGuid = getRecoveryGuid();
    if (recoveryGuid) {
      next();
    } else {
      next('/dashboard');  
    }
  },
  appSections(){
    return appSections.DASHBOARD;
  }
};

export default Gard



// WEBPACK FOOTER //
// ./src/router/gards.js